import "./new-util-category.scss";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilCategory from "../form-util-category/form-util-category";
import { useNewUtilCategory } from "./new-util-category.hook";

export function NewUtilCategory() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewUtilCategory();

  return (
    <div id="NewUtilCategory" className="util-category">
      <HeaderContent
        title={<h1>New Category</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormUtilCategory />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewUtilCategory;
